// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---------------------------------------------------------------------------
   THE PALETTE EVERY LOOK SHARES.

   Everything on this site that was built after the card itself -- the "Verified
   this show" window and its launcher, the confirmation toasts, the "live now"
   credit strip -- draws its colours from the custom properties below and from
   nothing else. Set them and those pieces follow; a new theme does not have to
   know that any of them exist.

   This file is the everyday look, and it is loaded for EVERY theme (a static
   import in components/whenplane/WhenPlane.js). A theme stylesheet is then laid
   on top of it -- see the switch in src/App.js -- so a theme only has to declare
   the handful of values it actually changes and inherits the rest from here.

   WRITING A NEW THEME. Ten of these carry almost all the weight:

       --wsb-surface        the panel's own colour
       --wsb-surface-2      the same colour, one shade deeper
       --wsb-ink            text on that panel
       --wsb-ink-muted      quieter text on that panel
       --wsb-line           hairlines drawn on that panel
       --wsb-accent         the one colour the look is built around
       --wsb-accent-ink     text drawn ON that colour
       --wsb-bar-bg         the fill behind a title bar
       --wsb-bar-ink        text on that bar
       --wsb-shadow         what the panel's shadow is made of

   The rest are refinements of those, and can be left alone until they look
   wrong. Two rules when picking values:

   1. CHECK THE CONTRAST. Every ink token is real text. Small text on a filled
      accent is the one that usually fails -- if in doubt, darken the fill or
      lighten the ink until text and background are 4.5:1 apart.
   2. NOTHING HERE CHANGES SIZE. These are colours, textures and shadows only.
      A theme swap must never move anything on the page.
--------------------------------------------------------------------------- */

:root {
  /* --- panels: a piece of paper laid on the page ------------------------- */
  --wsb-surface: #f2eedd;
  --wsb-surface-2: #e1ddcc;
  --wsb-surface-image: url("https://cdn.wanshow.bingo/resources/images/paper.png");
  --wsb-surface-hover: linear-gradient(to bottom, #fbb2b26d, #ffc8aabf);
  /* An inset hairline for a panel that would otherwise vanish into whatever is
     behind it. Transparent here: cream on orange needs no help. */
  --wsb-ring: transparent;

  --wsb-ink: #241a12;
  --wsb-ink-muted: #6d5a4c;

  --wsb-line: rgba(193, 62, 5, 0.28);
  --wsb-line-strong: rgba(193, 62, 5, 0.55);
  --wsb-shadow: rgba(0, 0, 0, 0.3);

  /* --- the one colour the look is built around --------------------------- */
  --wsb-accent: #c13e05;
  --wsb-accent-ink: #ffffff;

  /* --- a band filled with that colour: title bars ------------------------ */
  --wsb-bar-bg: linear-gradient(45deg, #c13e05, #912700);
  --wsb-bar-ink: #ffffff;
  --wsb-bar-ink-muted: #ffe6d9;
  --wsb-bar-glint: #ffd9c7;          /* the lit dot, and focus rings on the bar */
  --wsb-bar-hover: rgba(255, 255, 255, 0.22);

  --wsb-badge-bg: rgba(255, 255, 255, 0.9);
  --wsb-badge-ink: #912700;

  /* The accent as TEXT: the same colour pushed until it is legible at 11px on
     the surface. Burnt orange straight off the card is 3.9:1 on cream, which
     is not enough to read a category chip by. Used by the chips, the launcher's
     label and a host's initial -- everywhere the accent has to be read rather
     than just seen. */
  --wsb-accent-text: #a83605;

  --wsb-chip-bg: transparent;
  --wsb-chip-line: rgba(193, 62, 5, 0.45);

  --wsb-focus: #f2eedd;
  --wsb-snap-ring: rgba(255, 193, 94, 0.85);

  /* --- the strip that sits ON the card header, not on a panel ------------ */
  --wsb-onbrand-panel: rgba(0, 0, 0, 0.18);
  --wsb-onbrand-line: rgba(242, 238, 221, 0.35);
  --wsb-onbrand-ink: #f6f1e4;
  --wsb-onbrand-ink-muted: rgba(246, 241, 228, 0.82);

  /* --- toasts ------------------------------------------------------------ */
  /* The card's own burnt orange rather than the brighter one these used to be:
     white on that was 3.9:1, which is not enough to read a square's name by at
     a glance, and it was the one orange on the page that belonged to nothing.
     Nearly opaque, because a toast is read against whatever the page happens to
     be showing behind it. */
  --wsb-toast-bg: rgba(193, 62, 5, 0.9);
  --wsb-toast-bg-idle: rgba(145, 39, 0, 0.9);
  --wsb-toast-ink: #ffffff;

  /* --- status: on air, and the halo on a square confirmed on air --------- */
  --wsb-live: #ff3b30;
  --wsb-live-glow: rgba(255, 59, 48, 0.9);
  --wsb-verified-glow-soft: rgba(255, 193, 94, 0.18);
  --wsb-verified-glow-strong: rgba(255, 193, 94, 0.5);

  /* How long a colour takes to cross over when the look changes. Short: the
     After Dark fade already hides the swap, this is only for anything the veil
     does not cover. Honoured only when motion is welcome -- see the components. */
  --wsb-swap: 260ms;
}

* {
  font-family: 'Dosis', sans-serif;
  padding: 0px;
  margin: 0px;
}

body {
  background-color: #555;
  z-index: -4;
}

#my-canvas {
  position: absolute; /* Position the canvas absolutely within the parent */
  top: 0;
  left: 0;
  z-index: 0; /* Set a lower z-index value to place it behind other elements */
}

#back-img {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  /* background-color: #000; */
  /* background-image: linear-gradient(to bottom, #6699ff, #ff66cc); */
  background-image: url("https://wanshow.bingo/resources/images/helloworld.jpeg");
  background-size: cover;
  background-position: center;
  z-index: -2;
  opacity: 0.2;
  overflow: hidden;
}

.user-count {
  animation: typing 0.5s steps(20, end);
}

nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  background-color: #333333e1;
  position: relative;
  z-index: 1; /* Set a lower z-index value to place it behind other elements */
}

/*
.bingo-card {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  max-width: 500px;
  margin: 20px auto;
  padding: 15px;
  border-radius: 20px;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.3);
}
*/

/* Style for the hamburger menu */
/*.hamburger-menu {
  display: none; /* Hide the menu by default */
  /*position: relative;
  cursor: pointer;
}

/* Style for the open state of the hamburger icon */
/*.hamburger-menu.open .bar:nth-child(1) {
  transform: rotate(-45deg) translate(-5px, 6px);
}

.hamburger-menu.open .bar:nth-child(2) {
  opacity: 0;
}

.hamburger-menu.open .bar:nth-child(3) {
  transform: rotate(45deg) translate(-5px, -6px);
}

/* Style for the menu items */
.menu {
  display: none;
  position: absolute;
  top: 48px;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.menu a {
  display: block;
  padding: 12px 16px;
  text-decoration: none;
  color: #333;
  transition: background-color 0.3s;
}

.menu a:hover {
  background-color: #ddd;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
}

.nav-logo img {
  height: 40px;
}

.nav-links a {
  color: white;
  text-decoration: none;
  margin: 0 10px;
  font-size: 18px;
}

.nav-login a {
  color: white;
  text-decoration: none;
  font-size: 18px;
}

/* Apply styles to the theme selector dropdown */
#themeSelector {
  background-color: #d2480c;
  border: 1px solid #9a3206;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  color: #ffffff;
}

/* Apply styles to the label of the theme selector dropdown */
.theme-selector-label {
  font-weight: bold;
  color: #ffffff;
}


@keyframes typing {
  from {
    width: 0;
  }
}

#bodyWrapper {
  width: 1000px;
  display: block;
  margin: 0px auto;
  padding-top: 50px;
  padding-bottom: 50px;
}

#game {
  display: inline-block;
  background: linear-gradient(45deg, #c13e05, #912700);
  padding: 15px 10px;
  padding-left: 2.5px;
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 0px 0px 5px rgba(255, 69, 0, 0.2);
  filter: drop-shadow(0px 0px 2px rgba(255, 69, 0, 0.2));
}

#game p {
  line-height: 30px;
  text-shadow: 1px 1px 1px #00000056;
}

#game a {
  color: white;
}

.hidden {
  display: none;
}

.board {
  width: 1000px;
  margin: auto;
  /* display: block; */
  display: grid;
  grid-template-columns: auto auto auto auto auto;
}

#whenplane {
  padding-bottom: 10px;
}

#board {
  /* display: inline-grid; /* added to make the area a grid */
  position: relative; /* Added to position the background image */
  /* grid-template-columns: auto auto auto auto auto; /* gives the grid 5 columns no matter what size screen you are on */
  z-index: 1;  /*Added to stack the game board above the background image */
  transform-origin: top left; /* Scale from the top left corner */
  /*display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-wrap: wrap; Allow items to wrap onto the next line */
}

#board::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("https://cdn.wanshow.bingo/resources/images/linusclose.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed; /* Changed to fixed to keep the background image in place */
  z-index: -1; /* Stack the background image below the grid items */
}

.item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 5 - 10px); /* adjust the denominator based on how many items you want in a row */
  vertical-align: middle;
  text-align: center;
  width: 178px;
  height: 153px;
  border: 1px #c13e05 solid;
  background-image: url("https://cdn.wanshow.bingo/resources/images/paper.png");
  float: left;
  color: black;
  padding: 10px;
}

.item p {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.title {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-size: 32pt;
}

.clicked {
  background: linear-gradient(to right, #b5226200, #893f8e00);
  color: white;
  border-color: #f0dddd;
  animation: borderColorChange 2s infinite;
}

/*
@keyframes borderColorChange {
  0% {
    border-color: #FF0000;
  }
  16.67% {
    border-color: #FF6A00;
  }
  33.33% {
    border-color: #FFD800;
  }
  50% {
    border-color: #00FF00;
  }
  66.67% {
    border-color: #0000FF;
  }
  83.33% {
    border-color: #4B0082;
  }
  100% {
    border-color: #9400D3;
  }
}
*/

.footer {
  padding: 1rem 0;
  width: 100%;
  /* position: absolute; */
  bottom: 0;
}

.footer-container {
  display: flex;
  justify-content: space-around;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;
}

.footer-links {
  display: flex;
  align-items: center;
}

.footer-links a {
  color: #f2f2f2;
  text-decoration: none;
  margin-right: 1rem;
}

.footer-links a:hover {
  color: #e0e0e0;
}

/* Remove underline from footer & a href */
.footer-links a:hover {
  text-decoration: none;
}

.footer-copyright {
  color: #f2f2f2;
  font-size: 0.9rem;
}

a {
  color: white;
}

a:hover {
  color: #ff6600;
}

#team {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.section {
  flex: 0 0 48%; /* Each section will take up 48% of the available space */
  margin: 10px;
  /* Add media query to stack sections vertically on smaller screens */
}

.discord-banner {
  display: flex;
  align-items: center;
  background-color: #5865F2; /* Discord's blurple color from the color palette */
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.discord-icon {
  font-size: 18px;
  margin-right: 5px;
}

.discord-tag {
  font-size: 14px;
}

.member {
  /* width: calc(50% - 20px); */
  margin: 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
}

.member img {
  width: 150px;
  border-radius: 50%;
}

.member h2 {
  font-size: 24px;
  margin-top: 10px;
}

.member p {
  margin-top: 5px;
}

.member .social-links {
  margin-top: 10px;
}

.member .social-links a {
  color: #555;
  text-decoration: none;
  margin-right: 10px;
  font-size: 18px;
}

.member .social-links a:hover {
  color: #ff6600;
}

.countdown-box.svelte-1xheok0 {
  min-width: 23em;
  margin: 0 auto;
  font-family: "Dosis", sans-serif;
  background-color: #c13e05;
  padding: 15px 10px;
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
}

.countdown-box.svelte-1xheok0 {
  width: auto; /* Adjust to content */
  max-width: 550px;
  margin: 20px auto; /* Center the box */
  font-family: 'Dosis', sans-serif;
  background-color: #c13e05; /* LTT orange */
  padding: 15px 20px; /* Increased padding */
  text-align: center;
  color: white;
  font-size: 14pt;
  border-radius: 20px;
  box-shadow: 10px 10px 12px -15px black;
  white-space: nowrap; /* Prevents the text from wrapping */
}

.provider-text {
  font-size: 10pt;
  text-align: right;
  color: #ffffff;
}

#wan-show-timer a {
  text-decoration: none;
  color: inherit;
  display: block; /* Make the entire area clickable */
}

.discord-banner {
  display: flex;
  align-items: center;
  background-color: #5865F2; /* Discord's blurple color from the color palette */
  color: #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  width: -moz-fit-content;
  width: fit-content;
}

.discord-icon {
  font-size: 18px;
  margin-right: 5px;
}

.discord-tag {
  font-size: 14px;
}

.discord-tag {
  background-color: #5865F2; /* Discord's purple color from the color palette */
  padding: 5px 10px;
  border-radius: 15px;
  display: inline-block;
}

.discord-banner::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% + 10px);
  height: calc(100% + 10px);
  border-radius: 20px;
  z-index: -1;
}

.member {
  margin-bottom: 20px;
}

.section h2 {
  color: white;
}

@media (max-width: 768px) {
  .section {
    flex: 0 0 100%; /* On smaller screens, each section takes up 100% of the available space */
  }
}

@media (max-width: 768px) {
  .member {
    width: calc(50% - 18px);
  }
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    text-align: center;
  }

  .footer-links {
    margin-bottom: 0.5rem;
  }
}

@media (max-width: 3840px) {
  #game {
    transform: scale(1.0); /* Scale down to 90% on smaller screens */
    transform-origin: center;   
  }

  #nav-container {
    transform: scale(0.8); /* Scale down to 80% on even smaller screens */
    transform-origin: center;   
  }
}

@media (max-width: 1920px) {
  #game {
    transform: scale(0.98); /* Scale down to 90% on smaller screens */
    transform-origin: center;   
    padding-left: 10px;
  }

  #whenplane {
    transform: scale(0.98); 
  }
}

@media (max-width: 1200px) {
  #game {
    transform: scale(0.98);  
    transform-origin: center;   
    padding-left: 10px;
    margin-left: 18px;
  }

  #whenplane {
    transform: scale(0.98);
    margin-top: 0px;  
  }
}

@media (max-width: 1150px) {
  #game {
    transform: scale(0.96);  
    transform-origin: center;   
    padding-left: 10px;
    margin-left: 18px;
  }

  #whenplane {
    transform: scale(0.96);
    margin-top: -2px;  
  }
}

@media (max-width: 1100px) {
  #game {
    transform: scale(0.99);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }

  #whenplane {
    transform: scale(0.99);
    margin-top: 0px;  
  }
}

@media (max-width: 1070px) {
  #game {
    transform: scale(0.98);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1060px) {
  #game {
    transform: scale(0.97);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1050px) {
  #game {
    transform: scale(0.96);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1040px) {
  #game {
    transform: scale(0.95);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1030px) {
  #game {
    transform: scale(0.94);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1020px) {
  #game {
    transform: scale(0.93);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }
}

@media (max-width: 1010px) {
  #game {
    transform: scale(0.92);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
  }

  #whenplane {
    transform: scale(0.92);  
  }
}

@media (max-width: 1000px) {
  #game {
    transform: scale(0.91);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -80px;
  }
}

@media (max-width: 950px) {
  #game {
    transform: scale(0.86);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -100px;
  }
}

@media (max-width: 900px) {
  #game {
    transform: scale(0.81);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -120px;
  }

  #whenplane {
    transform: scale(0.81);
    margin-top: -125px;  
  }
}

@media (max-width: 850px) {
  #game {
    transform: scale(0.76);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 19px;
    margin-top: -140px;
  }

  #whenplane {
    transform: scale(0.76);
    margin-top: -150px;  
  }
}

@media (max-width: 800px) {
  #game {
    transform: scale(0.71);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 3px;
    margin-top: -160px;
  }

  #whenplane {
    transform: scale(0.71);
    margin-top: -175px;  
  }
}

@media (max-width: 750px) {
  #game {
    transform: scale(0.66);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 2px;
    margin-top: -180px;
  }

  #whenplane {
    transform: scale(0.66);
    margin-top: -200px;  
  }
}

@media (max-width: 600px) {
  #game {
    transform: scale(0.56);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 1px;
    margin-top: -200px;
  }

  #whenplane {
    transform: scale(0.56);
    margin-top: -275px;  
  }
}

@media (max-width: 550px) {
  #game {
    transform: scale(0.52);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -220px;
  }
}

@media (max-width: 500px) {
  #game {
    transform: scale(0.48);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -240px;
  }

  #whenplane {
    transform: scale(0.48);  
    padding-top: -50px;
  }
}

@media (max-width: 480px) {
  #game {
    transform: scale(0.46); /* Scale down to 50% on the smallest screens */
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -248px;
  }
}

@media (max-width: 450px) {
  #game {
    transform: scale(0.42);  
    transform-origin: left;   
    padding-left: 10px;
    margin-left: 0px;
    margin-top: -260px;
  }
}

@media (max-width: 768px) {
  .nav-links {
    display: none;
  }

  .hamburger-menu {
    display: block;
  }
}
/* ==================================================================
   MOBILE / NARROW SCREENS  (added 2026-08-09)

   The bingo card is a fixed 1000px design that was only ever shrunk
   with \`transform: scale()\`. transform shrinks what you SEE but not the
   layout box, so a phone still laid the page out ~1020px wide, the
   browser zoomed out to fit it on screen, and every square label ended
   up rendering at roughly 5px. The \`margin-top: -260px\` on #game
   existed only to claw back the empty space that the scaled-down box
   left behind, so it has to go with the transform.

   Below 1040px we lay the card out FLUIDLY instead of scaling it:
   five even columns that follow the screen width, with the cell
   proportions preserved via aspect-ratio.
   ================================================================== */
@media (max-width: 1040px) {
  #game {
    transform: none !important;
    width: auto !important;
    max-width: 100% !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding: 10px 6px !important;
    box-sizing: border-box !important;
  }

  #board,
  .bingo-card,
  .bingo-container,
  .board,
  .logo-refresh-container {
    width: auto !important;
    max-width: 100% !important;
    transform: none !important;
    box-sizing: border-box !important;
  }

  /* Five even columns that flex with the screen, instead of 178px cells. */
  .board {
    display: grid !important;
    grid-template-columns: repeat(5, 1fr) !important;
    gap: 0 !important;
  }

  .item {
    width: auto !important;
    height: auto !important;
    aspect-ratio: 178 / 153;      /* keep the original cell proportions */
    float: none !important;       /* float is meaningless in a grid */
    font-size: clamp(7px, 2.15vw, 18.6667px) !important;
    line-height: 1.15 !important;
    padding: 2px !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
  }

  /* The header row must be allowed to SHRINK. Its refresh button carries a
     fixed width tuned for the 1000px card and otherwise bursts out of the
     row, and any overflow widens the layout viewport, which then drags
     every position:fixed element off-screen with it. */
  .logo-refresh-container {
    flex-wrap: wrap !important;
    gap: 8px !important;
  }
  .inner-rfrsh-btn {
    flex: 0 1 auto !important;
    min-width: 0 !important;
    margin: 0 !important;
  }
  .sheet-link,
  #refreshButton,
  .refreshButton {
    width: auto !important;
    max-width: 100% !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }

  .notification-container {
    max-width: calc(100vw - 20px) !important;
  }
}

/* On phones, stack the header instead of squeezing three things into a row. */
@media (max-width: 700px) {
  .logo-refresh-container {
    display: flex !important;
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    align-items: center !important;
    justify-content: flex-start !important;
    height: auto !important;
    min-height: 0 !important;
    gap: 10px !important;
    padding: 10px 0 6px !important;
  }
  .logo-refresh-container > * {
    width: auto !important;
    max-width: 100% !important;
    margin: 0 !important;
  }
  .title {
    height: auto !important;
    line-height: 1.1 !important;
  }
  /* Reserves ~30px of dead space when no show is live and it has no content. */
  .inner-sheets:empty {
    display: none !important;
  }
  .inner-rfrsh-btn {
    padding: 0 !important;
    max-width: 100% !important;
  }
}

/* ------------------------------------------------------------------
   MOBILE NAV (added 2026-08-09)

   Each theme sheet does \`.nav-links { display: none }\` below 768px,
   intended to be replaced by a hamburger menu — but that menu was never
   finished (it is still commented out further up this file). The result
   was that Discord, Leaderboards, Status Page and Tile List were simply
   unreachable on a phone: the only working link in the bar was Login.

   Rather than build a menu behind a tap, just show the four links —
   there are only four, and they fit on one or two wrapped rows.
   ------------------------------------------------------------------ */
@media (max-width: 768px) {
  .nav-links {
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    align-items: center !important;
    gap: 4px 14px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
  }
  .nav-links a {
    padding: 4px 2px !important;   /* a slightly bigger tap target */
    white-space: nowrap !important;
  }
  .nav-container {
    flex-wrap: wrap !important;
    height: auto !important;
    justify-content: center !important;
    gap: 2px 10px !important;
    padding: 6px 10px !important;
  }
  nav {
    height: auto !important;
    min-height: 60px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/BingoCard.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6EAmC6E;;AAE7E;EACE,4EAA4E;EAC5E,sBAAsB;EACtB,wBAAwB;EACxB,gFAAgF;EAChF,qEAAqE;EACrE;kEACgE;EAChE,uBAAuB;;EAEvB,kBAAkB;EAClB,wBAAwB;;EAExB,kCAAkC;EAClC,yCAAyC;EACzC,gCAAgC;;EAEhC,4EAA4E;EAC5E,qBAAqB;EACrB,yBAAyB;;EAEzB,4EAA4E;EAC5E,sDAAsD;EACtD,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB,WAAW,4CAA4C;EAC/E,0CAA0C;;EAE1C,wCAAwC;EACxC,wBAAwB;;EAExB;;;;sBAIoB;EACpB,0BAA0B;;EAE1B,0BAA0B;EAC1B,uCAAuC;;EAEvC,oBAAoB;EACpB,yCAAyC;;EAEzC,4EAA4E;EAC5E,wCAAwC;EACxC,6CAA6C;EAC7C,0BAA0B;EAC1B,kDAAkD;;EAElD,4EAA4E;EAC5E;;;;4BAI0B;EAC1B,qCAAqC;EACrC,0CAA0C;EAC1C,wBAAwB;;EAExB,4EAA4E;EAC5E,mBAAmB;EACnB,uCAAuC;EACvC,kDAAkD;EAClD,mDAAmD;;EAEnD;;kFAEgF;EAChF,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB,EAAE,qDAAqD;EACzE,MAAM;EACN,OAAO;EACP,UAAU,EAAE,gEAAgE;AAC9E;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,4BAA4B;EAC5B,oEAAoE;EACpE,+EAA+E;EAC/E,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU,EAAE,gEAAgE;AAC9E;;AAEA;;;;;;;;;;;CAWC;;AAED,iCAAiC;AACjC;8CAC8C;EAC5C;;;;mDAIiD;AACnD;;;;;;;;;;;;6BAY6B;AAC7B;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,cAAc;AAChB;;;AAGA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6CAA6C;EAC7C,sDAAsD;AACxD;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB,EAAE,2CAA2C;EAC/D,uHAAuH;EACvH,UAAU,GAAG,4DAA4D;EACzE,0BAA0B,EAAE,mCAAmC;EAC/D;;;2DAGyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,kFAAkF;EAClF,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B,EAAE,2DAA2D;EACzF,WAAW,EAAE,oDAAoD;AACnE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B,EAAE,qEAAqE;EACnG,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,6EAA6E;EAC7E,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,YAAY;EACZ,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC;;AAED;EACE,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa,EAAE,yDAAyD;EACxE,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,mDAAmD;EAC9E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,gBAAgB;EAChB,iBAAiB,EAAE,mBAAmB;EACtC,gCAAgC;EAChC,yBAAyB,EAAE,eAAe;EAC1C,kBAAkB,EAAE,sBAAsB;EAC1C,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB,EAAE,oCAAoC;AAC3D;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB,EAAE,mDAAmD;EAC9E,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,kDAAkD;EAC7E,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,cAAc,EAAE,0EAA0E;EAC5F;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB,EAAE,yCAAyC;IAChE,wBAAwB;EAC1B;;EAEA;IACE,qBAAqB,EAAE,8CAA8C;IACrE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,yCAAyC;IACjE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB,EAAE,8CAA8C;IACtE,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;AACA;;;;;;;;;;;;;;uEAcuE;AACvE;EACE;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,0BAA0B;IAC1B,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;;;;;IAKE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,yEAAyE;EACzE;IACE,wBAAwB;IACxB,gDAAgD;IAChD,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB,OAAO,uCAAuC;IACrE,sBAAsB,QAAQ,mCAAmC;IACjE,mDAAmD;IACnD,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;;;uDAGqD;EACrD;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;EACA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,oBAAoB;EACtB;EACA;;;IAGE,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;IACpB,iCAAiC;EACnC;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA,8EAA8E;AAC9E;EACE;IACE,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,8BAA8B;IAC9B,sCAAsC;IACtC,uBAAuB;IACvB,wBAAwB;IACxB,oBAAoB;IACpB,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;EACA,6EAA6E;EAC7E;IACE,wBAAwB;EAC1B;EACA;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;AACF;;AAEA;;;;;;;;;;;uEAWuE;AACvE;EACE;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,kCAAkC;IAClC,8BAA8B;IAC9B,wBAAwB;IACxB,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,2BAA2B,IAAI,iCAAiC;IAChE,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,kCAAkC;IAClC,wBAAwB;IACxB,4BAA4B;EAC9B;EACA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;AACF","sourcesContent":["/* ---------------------------------------------------------------------------\n   THE PALETTE EVERY LOOK SHARES.\n\n   Everything on this site that was built after the card itself -- the \"Verified\n   this show\" window and its launcher, the confirmation toasts, the \"live now\"\n   credit strip -- draws its colours from the custom properties below and from\n   nothing else. Set them and those pieces follow; a new theme does not have to\n   know that any of them exist.\n\n   This file is the everyday look, and it is loaded for EVERY theme (a static\n   import in components/whenplane/WhenPlane.js). A theme stylesheet is then laid\n   on top of it -- see the switch in src/App.js -- so a theme only has to declare\n   the handful of values it actually changes and inherits the rest from here.\n\n   WRITING A NEW THEME. Ten of these carry almost all the weight:\n\n       --wsb-surface        the panel's own colour\n       --wsb-surface-2      the same colour, one shade deeper\n       --wsb-ink            text on that panel\n       --wsb-ink-muted      quieter text on that panel\n       --wsb-line           hairlines drawn on that panel\n       --wsb-accent         the one colour the look is built around\n       --wsb-accent-ink     text drawn ON that colour\n       --wsb-bar-bg         the fill behind a title bar\n       --wsb-bar-ink        text on that bar\n       --wsb-shadow         what the panel's shadow is made of\n\n   The rest are refinements of those, and can be left alone until they look\n   wrong. Two rules when picking values:\n\n   1. CHECK THE CONTRAST. Every ink token is real text. Small text on a filled\n      accent is the one that usually fails -- if in doubt, darken the fill or\n      lighten the ink until text and background are 4.5:1 apart.\n   2. NOTHING HERE CHANGES SIZE. These are colours, textures and shadows only.\n      A theme swap must never move anything on the page.\n--------------------------------------------------------------------------- */\n\n:root {\n  /* --- panels: a piece of paper laid on the page ------------------------- */\n  --wsb-surface: #f2eedd;\n  --wsb-surface-2: #e1ddcc;\n  --wsb-surface-image: url(\"https://cdn.wanshow.bingo/resources/images/paper.png\");\n  --wsb-surface-hover: linear-gradient(to bottom, #fbb2b26d, #ffc8aabf);\n  /* An inset hairline for a panel that would otherwise vanish into whatever is\n     behind it. Transparent here: cream on orange needs no help. */\n  --wsb-ring: transparent;\n\n  --wsb-ink: #241a12;\n  --wsb-ink-muted: #6d5a4c;\n\n  --wsb-line: rgba(193, 62, 5, 0.28);\n  --wsb-line-strong: rgba(193, 62, 5, 0.55);\n  --wsb-shadow: rgba(0, 0, 0, 0.3);\n\n  /* --- the one colour the look is built around --------------------------- */\n  --wsb-accent: #c13e05;\n  --wsb-accent-ink: #ffffff;\n\n  /* --- a band filled with that colour: title bars ------------------------ */\n  --wsb-bar-bg: linear-gradient(45deg, #c13e05, #912700);\n  --wsb-bar-ink: #ffffff;\n  --wsb-bar-ink-muted: #ffe6d9;\n  --wsb-bar-glint: #ffd9c7;          /* the lit dot, and focus rings on the bar */\n  --wsb-bar-hover: rgba(255, 255, 255, 0.22);\n\n  --wsb-badge-bg: rgba(255, 255, 255, 0.9);\n  --wsb-badge-ink: #912700;\n\n  /* The accent as TEXT: the same colour pushed until it is legible at 11px on\n     the surface. Burnt orange straight off the card is 3.9:1 on cream, which\n     is not enough to read a category chip by. Used by the chips, the launcher's\n     label and a host's initial -- everywhere the accent has to be read rather\n     than just seen. */\n  --wsb-accent-text: #a83605;\n\n  --wsb-chip-bg: transparent;\n  --wsb-chip-line: rgba(193, 62, 5, 0.45);\n\n  --wsb-focus: #f2eedd;\n  --wsb-snap-ring: rgba(255, 193, 94, 0.85);\n\n  /* --- the strip that sits ON the card header, not on a panel ------------ */\n  --wsb-onbrand-panel: rgba(0, 0, 0, 0.18);\n  --wsb-onbrand-line: rgba(242, 238, 221, 0.35);\n  --wsb-onbrand-ink: #f6f1e4;\n  --wsb-onbrand-ink-muted: rgba(246, 241, 228, 0.82);\n\n  /* --- toasts ------------------------------------------------------------ */\n  /* The card's own burnt orange rather than the brighter one these used to be:\n     white on that was 3.9:1, which is not enough to read a square's name by at\n     a glance, and it was the one orange on the page that belonged to nothing.\n     Nearly opaque, because a toast is read against whatever the page happens to\n     be showing behind it. */\n  --wsb-toast-bg: rgba(193, 62, 5, 0.9);\n  --wsb-toast-bg-idle: rgba(145, 39, 0, 0.9);\n  --wsb-toast-ink: #ffffff;\n\n  /* --- status: on air, and the halo on a square confirmed on air --------- */\n  --wsb-live: #ff3b30;\n  --wsb-live-glow: rgba(255, 59, 48, 0.9);\n  --wsb-verified-glow-soft: rgba(255, 193, 94, 0.18);\n  --wsb-verified-glow-strong: rgba(255, 193, 94, 0.5);\n\n  /* How long a colour takes to cross over when the look changes. Short: the\n     After Dark fade already hides the swap, this is only for anything the veil\n     does not cover. Honoured only when motion is welcome -- see the components. */\n  --wsb-swap: 260ms;\n}\n\n* {\n  font-family: 'Dosis', sans-serif;\n  padding: 0px;\n  margin: 0px;\n}\n\nbody {\n  background-color: #555;\n  z-index: -4;\n}\n\n#my-canvas {\n  position: absolute; /* Position the canvas absolutely within the parent */\n  top: 0;\n  left: 0;\n  z-index: 0; /* Set a lower z-index value to place it behind other elements */\n}\n\n#back-img {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  /* background-color: #000; */\n  /* background-image: linear-gradient(to bottom, #6699ff, #ff66cc); */\n  background-image: url(\"https://wanshow.bingo/resources/images/helloworld.jpeg\");\n  background-size: cover;\n  background-position: center;\n  z-index: -2;\n  opacity: 0.2;\n  overflow: hidden;\n}\n\n.user-count {\n  animation: typing 0.5s steps(20, end);\n}\n\nnav {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 60px;\n  background-color: #333333e1;\n  position: relative;\n  z-index: 1; /* Set a lower z-index value to place it behind other elements */\n}\n\n/*\n.bingo-card {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 10px;\n  max-width: 500px;\n  margin: 20px auto;\n  padding: 15px;\n  border-radius: 20px;\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.3);\n}\n*/\n\n/* Style for the hamburger menu */\n/*.hamburger-menu {\n  display: none; /* Hide the menu by default */\n  /*position: relative;\n  cursor: pointer;\n}\n\n/* Style for the open state of the hamburger icon */\n/*.hamburger-menu.open .bar:nth-child(1) {\n  transform: rotate(-45deg) translate(-5px, 6px);\n}\n\n.hamburger-menu.open .bar:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-menu.open .bar:nth-child(3) {\n  transform: rotate(45deg) translate(-5px, -6px);\n}\n\n/* Style for the menu items */\n.menu {\n  display: none;\n  position: absolute;\n  top: 48px;\n  right: 0;\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 1;\n}\n\n.menu a {\n  display: block;\n  padding: 12px 16px;\n  text-decoration: none;\n  color: #333;\n  transition: background-color 0.3s;\n}\n\n.menu a:hover {\n  background-color: #ddd;\n}\n\n.nav-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1200px;\n  padding: 0 20px;\n}\n\n.nav-logo img {\n  height: 40px;\n}\n\n.nav-links a {\n  color: white;\n  text-decoration: none;\n  margin: 0 10px;\n  font-size: 18px;\n}\n\n.nav-login a {\n  color: white;\n  text-decoration: none;\n  font-size: 18px;\n}\n\n/* Apply styles to the theme selector dropdown */\n#themeSelector {\n  background-color: #d2480c;\n  border: 1px solid #9a3206;\n  border-radius: 4px;\n  padding: 6px 12px;\n  font-size: 14px;\n  color: #ffffff;\n}\n\n/* Apply styles to the label of the theme selector dropdown */\n.theme-selector-label {\n  font-weight: bold;\n  color: #ffffff;\n}\n\n\n@keyframes typing {\n  from {\n    width: 0;\n  }\n}\n\n#bodyWrapper {\n  width: 1000px;\n  display: block;\n  margin: 0px auto;\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n#game {\n  display: inline-block;\n  background: linear-gradient(45deg, #c13e05, #912700);\n  padding: 15px 10px;\n  padding-left: 2.5px;\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 0px 0px 5px rgba(255, 69, 0, 0.2);\n  filter: drop-shadow(0px 0px 2px rgba(255, 69, 0, 0.2));\n}\n\n#game p {\n  line-height: 30px;\n  text-shadow: 1px 1px 1px #00000056;\n}\n\n#game a {\n  color: white;\n}\n\n.hidden {\n  display: none;\n}\n\n.board {\n  width: 1000px;\n  margin: auto;\n  /* display: block; */\n  display: grid;\n  grid-template-columns: auto auto auto auto auto;\n}\n\n#whenplane {\n  padding-bottom: 10px;\n}\n\n#board {\n  /* display: inline-grid; /* added to make the area a grid */\n  position: relative; /* Added to position the background image */\n  /* grid-template-columns: auto auto auto auto auto; /* gives the grid 5 columns no matter what size screen you are on */\n  z-index: 1;  /*Added to stack the game board above the background image */\n  transform-origin: top left; /* Scale from the top left corner */\n  /*display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  flex-wrap: wrap; Allow items to wrap onto the next line */\n}\n\n#board::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"https://cdn.wanshow.bingo/resources/images/linusclose.jpg\");\n  background-size: cover;\n  background-position: center;\n  background-attachment: fixed; /* Changed to fixed to keep the background image in place */\n  z-index: -1; /* Stack the background image below the grid items */\n}\n\n.item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% / 5 - 10px); /* adjust the denominator based on how many items you want in a row */\n  vertical-align: middle;\n  text-align: center;\n  width: 178px;\n  height: 153px;\n  border: 1px #c13e05 solid;\n  background-image: url(\"https://cdn.wanshow.bingo/resources/images/paper.png\");\n  float: left;\n  color: black;\n  padding: 10px;\n}\n\n.item p {\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.title {\n  width: 100%;\n  text-align: center;\n  margin-top: 15px;\n  font-size: 32pt;\n}\n\n.clicked {\n  background: linear-gradient(to right, #b5226200, #893f8e00);\n  color: white;\n  border-color: #f0dddd;\n  animation: borderColorChange 2s infinite;\n}\n\n/*\n@keyframes borderColorChange {\n  0% {\n    border-color: #FF0000;\n  }\n  16.67% {\n    border-color: #FF6A00;\n  }\n  33.33% {\n    border-color: #FFD800;\n  }\n  50% {\n    border-color: #00FF00;\n  }\n  66.67% {\n    border-color: #0000FF;\n  }\n  83.33% {\n    border-color: #4B0082;\n  }\n  100% {\n    border-color: #9400D3;\n  }\n}\n*/\n\n.footer {\n  padding: 1rem 0;\n  width: 100%;\n  /* position: absolute; */\n  bottom: 0;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.footer-links {\n  display: flex;\n  align-items: center;\n}\n\n.footer-links a {\n  color: #f2f2f2;\n  text-decoration: none;\n  margin-right: 1rem;\n}\n\n.footer-links a:hover {\n  color: #e0e0e0;\n}\n\n/* Remove underline from footer & a href */\n.footer-links a:hover {\n  text-decoration: none;\n}\n\n.footer-copyright {\n  color: #f2f2f2;\n  font-size: 0.9rem;\n}\n\na {\n  color: white;\n}\n\na:hover {\n  color: #ff6600;\n}\n\n#team {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.section {\n  flex: 0 0 48%; /* Each section will take up 48% of the available space */\n  margin: 10px;\n  /* Add media query to stack sections vertically on smaller screens */\n}\n\n.discord-banner {\n  display: flex;\n  align-items: center;\n  background-color: #5865F2; /* Discord's blurple color from the color palette */\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: fit-content;\n}\n\n.discord-icon {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.discord-tag {\n  font-size: 14px;\n}\n\n.member {\n  /* width: calc(50% - 20px); */\n  margin: 10px;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  position: relative;\n}\n\n.member img {\n  width: 150px;\n  border-radius: 50%;\n}\n\n.member h2 {\n  font-size: 24px;\n  margin-top: 10px;\n}\n\n.member p {\n  margin-top: 5px;\n}\n\n.member .social-links {\n  margin-top: 10px;\n}\n\n.member .social-links a {\n  color: #555;\n  text-decoration: none;\n  margin-right: 10px;\n  font-size: 18px;\n}\n\n.member .social-links a:hover {\n  color: #ff6600;\n}\n\n.countdown-box.svelte-1xheok0 {\n  min-width: 23em;\n  margin: 0 auto;\n  font-family: \"Dosis\", sans-serif;\n  background-color: #c13e05;\n  padding: 15px 10px;\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n}\n\n.countdown-box.svelte-1xheok0 {\n  width: auto; /* Adjust to content */\n  max-width: 550px;\n  margin: 20px auto; /* Center the box */\n  font-family: 'Dosis', sans-serif;\n  background-color: #c13e05; /* LTT orange */\n  padding: 15px 20px; /* Increased padding */\n  text-align: center;\n  color: white;\n  font-size: 14pt;\n  border-radius: 20px;\n  box-shadow: 10px 10px 12px -15px black;\n  white-space: nowrap; /* Prevents the text from wrapping */\n}\n\n.provider-text {\n  font-size: 10pt;\n  text-align: right;\n  color: #ffffff;\n}\n\n#wan-show-timer a {\n  text-decoration: none;\n  color: inherit;\n  display: block; /* Make the entire area clickable */\n}\n\n.discord-banner {\n  display: flex;\n  align-items: center;\n  background-color: #5865F2; /* Discord's blurple color from the color palette */\n  color: #fff;\n  padding: 5px;\n  border-radius: 5px;\n  margin-top: 10px;\n  width: fit-content;\n}\n\n.discord-icon {\n  font-size: 18px;\n  margin-right: 5px;\n}\n\n.discord-tag {\n  font-size: 14px;\n}\n\n.discord-tag {\n  background-color: #5865F2; /* Discord's purple color from the color palette */\n  padding: 5px 10px;\n  border-radius: 15px;\n  display: inline-block;\n}\n\n.discord-banner::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: calc(100% + 10px);\n  height: calc(100% + 10px);\n  border-radius: 20px;\n  z-index: -1;\n}\n\n.member {\n  margin-bottom: 20px;\n}\n\n.section h2 {\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .section {\n    flex: 0 0 100%; /* On smaller screens, each section takes up 100% of the available space */\n  }\n}\n\n@media (max-width: 768px) {\n  .member {\n    width: calc(50% - 18px);\n  }\n}\n\n@media (max-width: 768px) {\n  .footer-container {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .footer-links {\n    margin-bottom: 0.5rem;\n  }\n}\n\n@media (max-width: 3840px) {\n  #game {\n    transform: scale(1.0); /* Scale down to 90% on smaller screens */\n    transform-origin: center;   \n  }\n\n  #nav-container {\n    transform: scale(0.8); /* Scale down to 80% on even smaller screens */\n    transform-origin: center;   \n  }\n}\n\n@media (max-width: 1920px) {\n  #game {\n    transform: scale(0.98); /* Scale down to 90% on smaller screens */\n    transform-origin: center;   \n    padding-left: 10px;\n  }\n\n  #whenplane {\n    transform: scale(0.98); \n  }\n}\n\n@media (max-width: 1200px) {\n  #game {\n    transform: scale(0.98);  \n    transform-origin: center;   \n    padding-left: 10px;\n    margin-left: 18px;\n  }\n\n  #whenplane {\n    transform: scale(0.98);\n    margin-top: 0px;  \n  }\n}\n\n@media (max-width: 1150px) {\n  #game {\n    transform: scale(0.96);  \n    transform-origin: center;   \n    padding-left: 10px;\n    margin-left: 18px;\n  }\n\n  #whenplane {\n    transform: scale(0.96);\n    margin-top: -2px;  \n  }\n}\n\n@media (max-width: 1100px) {\n  #game {\n    transform: scale(0.99);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n\n  #whenplane {\n    transform: scale(0.99);\n    margin-top: 0px;  \n  }\n}\n\n@media (max-width: 1070px) {\n  #game {\n    transform: scale(0.98);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1060px) {\n  #game {\n    transform: scale(0.97);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1050px) {\n  #game {\n    transform: scale(0.96);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1040px) {\n  #game {\n    transform: scale(0.95);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1030px) {\n  #game {\n    transform: scale(0.94);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1020px) {\n  #game {\n    transform: scale(0.93);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n}\n\n@media (max-width: 1010px) {\n  #game {\n    transform: scale(0.92);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n  }\n\n  #whenplane {\n    transform: scale(0.92);  \n  }\n}\n\n@media (max-width: 1000px) {\n  #game {\n    transform: scale(0.91);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -80px;\n  }\n}\n\n@media (max-width: 950px) {\n  #game {\n    transform: scale(0.86);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -100px;\n  }\n}\n\n@media (max-width: 900px) {\n  #game {\n    transform: scale(0.81);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -120px;\n  }\n\n  #whenplane {\n    transform: scale(0.81);\n    margin-top: -125px;  \n  }\n}\n\n@media (max-width: 850px) {\n  #game {\n    transform: scale(0.76);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 19px;\n    margin-top: -140px;\n  }\n\n  #whenplane {\n    transform: scale(0.76);\n    margin-top: -150px;  \n  }\n}\n\n@media (max-width: 800px) {\n  #game {\n    transform: scale(0.71);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 3px;\n    margin-top: -160px;\n  }\n\n  #whenplane {\n    transform: scale(0.71);\n    margin-top: -175px;  \n  }\n}\n\n@media (max-width: 750px) {\n  #game {\n    transform: scale(0.66);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 2px;\n    margin-top: -180px;\n  }\n\n  #whenplane {\n    transform: scale(0.66);\n    margin-top: -200px;  \n  }\n}\n\n@media (max-width: 600px) {\n  #game {\n    transform: scale(0.56);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 1px;\n    margin-top: -200px;\n  }\n\n  #whenplane {\n    transform: scale(0.56);\n    margin-top: -275px;  \n  }\n}\n\n@media (max-width: 550px) {\n  #game {\n    transform: scale(0.52);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -220px;\n  }\n}\n\n@media (max-width: 500px) {\n  #game {\n    transform: scale(0.48);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -240px;\n  }\n\n  #whenplane {\n    transform: scale(0.48);  \n    padding-top: -50px;\n  }\n}\n\n@media (max-width: 480px) {\n  #game {\n    transform: scale(0.46); /* Scale down to 50% on the smallest screens */\n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -248px;\n  }\n}\n\n@media (max-width: 450px) {\n  #game {\n    transform: scale(0.42);  \n    transform-origin: left;   \n    padding-left: 10px;\n    margin-left: 0px;\n    margin-top: -260px;\n  }\n}\n\n@media (max-width: 768px) {\n  .nav-links {\n    display: none;\n  }\n\n  .hamburger-menu {\n    display: block;\n  }\n}\n/* ==================================================================\n   MOBILE / NARROW SCREENS  (added 2026-08-09)\n\n   The bingo card is a fixed 1000px design that was only ever shrunk\n   with `transform: scale()`. transform shrinks what you SEE but not the\n   layout box, so a phone still laid the page out ~1020px wide, the\n   browser zoomed out to fit it on screen, and every square label ended\n   up rendering at roughly 5px. The `margin-top: -260px` on #game\n   existed only to claw back the empty space that the scaled-down box\n   left behind, so it has to go with the transform.\n\n   Below 1040px we lay the card out FLUIDLY instead of scaling it:\n   five even columns that follow the screen width, with the cell\n   proportions preserved via aspect-ratio.\n   ================================================================== */\n@media (max-width: 1040px) {\n  #game {\n    transform: none !important;\n    width: auto !important;\n    max-width: 100% !important;\n    margin-top: 0 !important;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n    padding: 10px 6px !important;\n    box-sizing: border-box !important;\n  }\n\n  #board,\n  .bingo-card,\n  .bingo-container,\n  .board,\n  .logo-refresh-container {\n    width: auto !important;\n    max-width: 100% !important;\n    transform: none !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Five even columns that flex with the screen, instead of 178px cells. */\n  .board {\n    display: grid !important;\n    grid-template-columns: repeat(5, 1fr) !important;\n    gap: 0 !important;\n  }\n\n  .item {\n    width: auto !important;\n    height: auto !important;\n    aspect-ratio: 178 / 153;      /* keep the original cell proportions */\n    float: none !important;       /* float is meaningless in a grid */\n    font-size: clamp(7px, 2.15vw, 18.6667px) !important;\n    line-height: 1.15 !important;\n    padding: 2px !important;\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n  }\n\n  /* The header row must be allowed to SHRINK. Its refresh button carries a\n     fixed width tuned for the 1000px card and otherwise bursts out of the\n     row, and any overflow widens the layout viewport, which then drags\n     every position:fixed element off-screen with it. */\n  .logo-refresh-container {\n    flex-wrap: wrap !important;\n    gap: 8px !important;\n  }\n  .inner-rfrsh-btn {\n    flex: 0 1 auto !important;\n    min-width: 0 !important;\n    margin: 0 !important;\n  }\n  .sheet-link,\n  #refreshButton,\n  .refreshButton {\n    width: auto !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    box-sizing: border-box !important;\n  }\n\n  .notification-container {\n    max-width: calc(100vw - 20px) !important;\n  }\n}\n\n/* On phones, stack the header instead of squeezing three things into a row. */\n@media (max-width: 700px) {\n  .logo-refresh-container {\n    display: flex !important;\n    flex-direction: column !important;\n    flex-wrap: nowrap !important;\n    align-items: center !important;\n    justify-content: flex-start !important;\n    height: auto !important;\n    min-height: 0 !important;\n    gap: 10px !important;\n    padding: 10px 0 6px !important;\n  }\n  .logo-refresh-container > * {\n    width: auto !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n  }\n  .title {\n    height: auto !important;\n    line-height: 1.1 !important;\n  }\n  /* Reserves ~30px of dead space when no show is live and it has no content. */\n  .inner-sheets:empty {\n    display: none !important;\n  }\n  .inner-rfrsh-btn {\n    padding: 0 !important;\n    max-width: 100% !important;\n  }\n}\n\n/* ------------------------------------------------------------------\n   MOBILE NAV (added 2026-08-09)\n\n   Each theme sheet does `.nav-links { display: none }` below 768px,\n   intended to be replaced by a hamburger menu — but that menu was never\n   finished (it is still commented out further up this file). The result\n   was that Discord, Leaderboards, Status Page and Tile List were simply\n   unreachable on a phone: the only working link in the bar was Login.\n\n   Rather than build a menu behind a tap, just show the four links —\n   there are only four, and they fit on one or two wrapped rows.\n   ------------------------------------------------------------------ */\n@media (max-width: 768px) {\n  .nav-links {\n    display: flex !important;\n    flex-wrap: wrap !important;\n    justify-content: center !important;\n    align-items: center !important;\n    gap: 4px 14px !important;\n    font-size: 12px !important;\n    line-height: 1.4 !important;\n  }\n  .nav-links a {\n    padding: 4px 2px !important;   /* a slightly bigger tap target */\n    white-space: nowrap !important;\n  }\n  .nav-container {\n    flex-wrap: wrap !important;\n    height: auto !important;\n    justify-content: center !important;\n    gap: 2px 10px !important;\n    padding: 6px 10px !important;\n  }\n  nav {\n    height: auto !important;\n    min-height: 60px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
